import AppHeader from '../AppHeader'
import MasterComsumableItemInput from '../MasterComsumableItemInput'
const utils = require('../../utils')
export default {
  name: 'master-consumable-item-edit',
  async created () {
    await this.getCategory()
    await this.getSupplier()
    await this.getConsumableItem()
    this.stockCheckPeriod()
    this.isShow = true
  },
  data () {
    return {
      consumableItem: {},
      categories: [],
      suppliers: [],
      displayImageUrl: '',
      isShow: false,
      isStockCheckPeriod: false
    }
  },
  computed: {
    imagePath () {
      return this.consumableItem.image_path + '?token=' + window.localStorage.getItem('access_token')
    }
  },
  components: {
    AppHeader,
    MasterComsumableItemInput
  },
  methods: {
    onFileChange (event) {
      const file = event.target.files || event.dataTransfer.files
      this.consumableItem.image = file[0]
      this.upload(file[0])
    },
    upload: function (file) {
      const reader = new FileReader()
      const self = this
      reader.onload = (e) => {
        self.displayImageUrl = e.target.result
      }
      reader.readAsDataURL(file)
    },
    deleteFile () {
      this.consumableItem.image = ''
      this.consumableItem.image_path = ''
      this.displayImageUrl = ''
    },
    async getCategory () {
      let data = {}
      let res = await this.$store.dispatch('GET_CATEGORY_LIST', {data: data})
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.categories = res.categories
    },
    async getSupplier () {
      let data = {}
      let res = await this.$store.dispatch('GET_SUPPLIER_LIST', {data: data})
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.suppliers = res.suppliers
    },
    async getConsumableItem () {
      let data = this.$route.params.consumable_item_id
      let res = await this.$store.dispatch('CONSUMABLE_ITEM_SHOW', {id: data})
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
      this.consumableItem = await utils.kebabSnakeConversion(res.data.attributes)
    },
    async updateConsumableItem (formData) {
      formData.append('image', this.consumableItem.image)
      await this.$store.dispatch('CONSUMABLE_ITEM_UPDATE', {data: formData})
                        .catch(err => {
                          console.log(err)
                          return
                        })
      this.$router.push('/master_consumable_item_list')
    },
    async stockCheckPeriod () {
      const res = await this.$store.dispatch('STOCK_CHECK_PERIOD_STORE')
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
      this.isStockCheckPeriod = res.data
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-consumable-item-edit.js